/** @typedef {'mostRecent' | '5' | '4' | '3' | '2' | '1'} BeerReviewRatingFilter */

export const BEER_REVIEW_RATING_FILTER_OPTIONS = [
  { value: 'mostRecent', label: 'Most Recent' },
  { value: '5', label: '5 Taps' },
  { value: '4', label: '4 Taps' },
  { value: '3', label: '3 Taps' },
  { value: '2', label: '2 Taps' },
  { value: '1', label: '1 Tap' },
];

/**
 * Returns whether a fractional overall rating falls in a tap bucket.
 * Buckets: 1 Tap (>0–1], 2 Taps (>1–2], …, 5 Taps (>4–5].
 * @param {number} overall
 * @param {1 | 2 | 3 | 4 | 5} tapLevel
 * @returns {boolean}
 */
export function matchesTapRatingBucket(overall, tapLevel) {
  if (typeof overall !== 'number' || Number.isNaN(overall)) {
    return false;
  }

  const lowerBound = tapLevel - 1;
  return overall > lowerBound && overall <= tapLevel;
}

/**
 * Filters loaded beer reviews by overall rating in memory.
 * Reviews without ratings.overall are excluded from tap filters but included under mostRecent.
 * Tap buckets support fractional ratings (0.25 increments): 1 Tap is (>0, 1], etc.
 * @param {Array<{ ratings?: { overall?: number } }>} reviews
 * @param {BeerReviewRatingFilter} filterValue
 * @returns {Array<{ ratings?: { overall?: number } }>}
 */
export function filterBeerReviewsByRating(reviews, filterValue) {
  if (!Array.isArray(reviews)) {
    return [];
  }
  if (filterValue === 'mostRecent') {
    return reviews;
  }

  const tapLevel = Number(filterValue);
  if (Number.isNaN(tapLevel) || tapLevel < 1 || tapLevel > 5) {
    return reviews;
  }

  return reviews.filter((review) => {
    const overall = review?.ratings?.overall;
    return matchesTapRatingBucket(overall, /** @type {1|2|3|4|5} */ (tapLevel));
  });
}
